import styled, { keyframes } from 'styled-components'

import { Z_INDEX_LOADING } from 'src/constants/z-indexes'

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: ${Z_INDEX_LOADING};
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.8);
`

const heartBeatAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
`

export const HeartBeatScale = styled.div`
  animation: ${heartBeatAnimation} 1s linear infinite;
`

export const CenterBlock = styled.div`
  display: flex;
  justify-content: center;
`
